export default "__VITE_PUBLIC_ASSET__a807e92a__"